import { useAppStore } from "@/store";
import { observer } from "mobx-react-lite";
import styled from "@emotion/styled";
import { AudioCaptureWaveForm } from "./AudioCaptureWaveForm";

interface AudioCaptureIndicatorProps {
  className?: string;
  expanded?: boolean;
  onClickElse?: () => void;
}

export const AudioCaptureIndicator = observer(function AudioCaptureIndicator({
  className,
  expanded = false,
  onClickElse,
}: AudioCaptureIndicatorProps) {
  const { store } = useAppStore();
  const { activeNoteId, formattedDuration, isIndicatorVisible } = store.audioCapture;

  if (!isIndicatorVisible) return null;
  return (
    <StyledButton
      className={className}
      expanded={expanded}
      onClick={() => {
        if (!activeNoteId) {
          onClickElse?.();
          return;
        }
        if (store.routing.noteIdParam === activeNoteId) {
          onClickElse?.();
          return;
        }
        store.navigation.goToNote({ noteId: activeNoteId });
      }}
    >
      <AudioCaptureWaveForm />
      {expanded && <StyledText>{formattedDuration}</StyledText>}
    </StyledButton>
  );
});

const StyledButton = styled.button<{ expanded: boolean }>`
  height: 32px;
  width: ${({ expanded }) => (expanded ? "auto" : "32px")};
  padding: ${({ expanded }) => (expanded ? "8px 12px" : "8px")};
  background-color: ${({ theme }) => theme.colors.red.x500};
  border-radius: ${({ theme }) => theme.borderRadius.mediumLarge}px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

const StyledText = styled.span`
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.fontSizes.small};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;
